import React from 'react';
import qs from 'qs';
import {
  AccountBalance,
  QuestionAnswer,
  WorkspacePremium,
  Help,
  IntegrationInstructions,
  Folder,
  HistoryEdu,
  EventAvailable,
} from '@mui/icons-material';

import ItemCreationCard from '../ItemCreationCard';
import { PostTypes } from '../../../Utils/Types';
import { PostTypeOrSurvey } from '../../../Utils/Types/Posts';
import { Space } from '../../../Utils/Types/Space';

interface PostCreationCardProps {
  space: Space;
  type: PostTypeOrSurvey;
  parentId?: string | number | null;
}

function PostCreationCard({ space, type, parentId }: PostCreationCardProps) {
  const { slug } = space;

  const queryParams = parentId ? { parent_id: parentId } : {};
  const queryParamsStringified = qs.stringify(queryParams);
  const queryString = queryParamsStringified ? `?${queryParamsStringified}` : '';

  const menuItems = [
    {
      type: PostTypes.FOLDER,
      icon: Folder,
      descriptionId: 'POSTS.CREATE_MENU.FOLDER.DESCRIPTION',
      to: `/${slug}/dashboard/posts/folders/new${queryString}`,
    },
    {
      type: PostTypes.PARTICIPATORY_BUDGET,
      icon: AccountBalance,
      descriptionId: 'POSTS.CREATE_MENU.PARTICIPATORY_BUDGET.DESCRIPTION',
      steps: 4,
      to: `/${slug}/dashboard/posts/participatory_budgets/new${queryString}`,
    },
    {
      type: PostTypes.COLLABORATIVE_DECISION,
      icon: QuestionAnswer,
      descriptionId: 'POSTS.CREATE_MENU.COLLABORATIVE_DECISION.DESCRIPTION',
      steps: 4,
      to: `/${slug}/dashboard/posts/collaborative_decisions/new${queryString}`,
    },
    {
      type: PostTypes.IDEAS_REQUEST,
      icon: WorkspacePremium,
      descriptionId: 'POSTS.CREATE_MENU.IDEAS_REQUEST.DESCRIPTION',
      steps: 2,
      to: `/${slug}/dashboard/posts/ideas_requests/new${queryString}`,
    },
    {
      type: 'survey',
      icon: Help,
      descriptionId: 'POSTS.CREATE_MENU.SURVEY.DESCRIPTION',
      steps: 1,
      to: `/${slug}/dashboard/posts/studies/new?${qs.stringify({ ...queryParams, form_builder: true })}`,
    },
    {
      type: PostTypes.STUDY,
      icon: IntegrationInstructions,
      descriptionId: 'POSTS.CREATE_MENU.STUDY.DESCRIPTION',
      titleId: 'POSTS.CREATE_MENU.STUDY.TITLE',
      steps: 1,
      to: `/${slug}/dashboard/posts/studies/new${queryString}`,
    },
    {
      type: PostTypes.ARTICLE,
      icon: HistoryEdu,
      descriptionId: 'POSTS.CREATE_MENU.ARTICLE.DESCRIPTION',
      to: `/${slug}/dashboard/posts/articles/new${queryString}`,
    },
    {
      type: PostTypes.EVENT,
      icon: EventAvailable,
      descriptionId: 'POSTS.CREATE_MENU.EVENT.DESCRIPTION',
      to: `/${slug}/dashboard/posts/events/new${queryString}`,
    },
  ];

  const item = menuItems.find((item) => item.type === type);

  if (!item) return null;

  return (
    <ItemCreationCard
      titleId={item.titleId || `DASHBOARD.FILTERS.TYPES.${type.toUpperCase()}`}
      descriptionId={item.descriptionId}
      icon={item.icon}
      steps={item.steps}
      to={item.to}
    />
  );
}

export default PostCreationCard;
